module.exports = __webpack_public_path__ + "static/media/print-template.6cab086a.png";